
import {
    info
} from '../../../core/js/utils/logger';
import { utagView } from '../../../core/js/utils/analyticsUtils';

export function accountTags() {
    return {
        account_dashboard: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_dashboard_page_id
                });
                info('utag.view fired: account_dashboard');
            }
        },
        account_settings: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_settings_page_id
                });
                info('utag.view fired: account_settings');
            }
        },
        account_address: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_address_page_id
                });
                info('utag.view fired: account_address');
            }
        },
        account_address_create: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_address_create_page_id
                });
                info('utag.view fired: account_address_create');
            }
        },
        account_address_edit: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_address_edit_page_id
                });
                info('utag.view fired: account_address_edit');
            }
        },
        account_address_delete: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_address_delete_page_id
                });
                info('utag.view fired: account_address_delete');
            }
        },
        account_payment_create: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_payment_create_page_id
                });
                info('utag.view fired: account_payment_create');
            }
        },
        account_payment_edit: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_payment_edit_page_id
                });
                info('utag.view fired: account_payment_edit');
            }
        },
        account_payment_delete: (state, action) => {
            return () =>{
                utagView({
                    page_id: state.core.localizations.containers.analyticsContainer.account_payment_delete_page_id
                });
                info('utag.view fired: account_payment_delete');
            }
        }
    }
}
